import React from "react";
import { useLocation } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import { API, Auth } from "aws-amplify";

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from '@material-ui/icons/Clear';



const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  title: {
    fontSize: "1rem",
  },
}));


async function loadVendors() {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return API.post("API", "/Vendors", init);
}

export default function VendorSelect({
  ...props
}) {
  const classes = useStyles();
  let location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [isReset, setReset] = React.useState(false);
  
  const [options, setOptions] = React.useState([]);
  const [aktualVendor, setVendor] = React.useState({alias:'', vendor_id:''});
  const [loading, setLoading] = React.useState(false);

  function selectHandler(value) {
    if (!value || !value.vendor_id) return
    props.props.setVendorID(value.vendor_id)
    setVendor(value)
  }

  function clearHandler(value) {
    props.props.setVendorID('')
    setVendor({alias: '', vendor_id: ''})
    setReset(!isReset)
  }

  React.useEffect(() => {
    let active = true;
    setLoading(true);
 
    (async () => {
      const response = await loadVendors();
      const vendors = await response.data.sort((a, b) => (a.alias > b.alias ? 1 : -1));
      if (active) {
        setOptions(vendors);
        setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  // Sync aktualVendor with vendorID from parent when options change or vendorID changes
  React.useEffect(() => {
    if (options.length > 0 && props.props.vendorID) {
      const vndr = options.find(option => option.vendor_id === props.props.vendorID);
      if (vndr && vndr.vendor_id !== aktualVendor.vendor_id) {
        setVendor(vndr);
      }
    } else if (!props.props.vendorID && aktualVendor.vendor_id) {
      setVendor({alias: '', vendor_id: ''});
    }
  }, [options, props.props.vendorID]);


  return (

    <Card
      className={classes.root}
      square
    >
      {location.pathname === '/Monitor' ? (<></>) : (<CardContent>
          <Typography className={classes.title} gutterBottom>
            Profil
          </Typography>
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
            direction="row">
            <Grid item style={{ width: 275 }}>
              <Typography variant="body2" component="p">
                Skift imellem vendors for at redigere. Denne funktion vil også virke som filter på underliggende sider.
              </Typography>
            </Grid>
            <Grid item>
              <Grid container
                justifyContent="flex-start"
                alignItems="center"
                direction="row"
              >
                <Grid item>
                  <Autocomplete
                    style={{ width: 350 }}
                    key={isReset}
                    disableClearable
                    id="asynchronous-demo"
                    open={open}
                    onOpen={() => { setOpen(true); }}
                    onClose={() => { setOpen(false); }}
                    onChange={(event, value) => selectHandler(value)}
                    // value={options.find( option =>  option.vendor_id === props.props.vendorID) }
                    value={ aktualVendor.vendor_id ? aktualVendor : null }
                    getOptionLabel={option => option.alias || ''}
                    options={options}
                    loading={loading}
                    isOptionEqualToValue={(option, value) => option.vendor_id === value.vendor_id}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Profil"
                        variant="filled"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                    
                  />
                </Grid>
                <Grid item>
                  <IconButton aria-label="delete" className={classes.margin} onClick={clearHandler}>
                    <ClearIcon />
                  </IconButton>
                </Grid>
              </Grid>

            </Grid>
          </Grid>


        </CardContent>)}
    </Card>
  )
}
